import { FunctionComponent } from "react";
import { appTheme, cn } from "../theme";

export const PadSize: FunctionComponent<{ size: string; title?: string }> = (props) => {
  if (!props.size || props.size === 'none') return <></>;

  // assume large and reduce as needed
  let w = 20;
  let t = 'L';
  if (props.size === 'medium') {
    w = 13;
    t = 'M';
  } else if (props.size === 'small') {
    w = 7;
    t = 'S';
  }

  return <div
    className={`pad-size ${cn.padSize}`}
    title={props.title ?? `Pad size: ${props.size}`}
    style={{
      display: 'inline-block',
      marginLeft: 4,
      width: w,
      height: 10,
    }}
  >
    <span style={{ position: 'relative', top: -2, color: appTheme.palette.themeDark }}>{t}</span>
  </div>;
};
